exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../node_modules/css-loader/index.js!vue-multiselect/dist/vue-multiselect.min.css"), "");

// module
exports.push([module.id, ".adminAuditsWrapper .b-table{min-width:1800px}.adminAuditsWrapper .b-table td,.adminAuditsWrapper .b-table th{font-size:.75rem}@media (max-width:767px){.adminAuditsWrapper .multiselect{width:100%}}", ""]);

// exports
